
import { ChangeDetectionStrategy, Component, SecurityContext } from '@angular/core';
import { DEFAULT_ATTRIBUTE_ALLOWLIST, HtmlComponent } from '@knorr-bremse-portals/ngx-components/components/html';
import { SectionComponent } from '../../../app/components/section/section.component';
import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { AnyInnerSection, Section, SectionAttributes } from '../../../app/types/section';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

export type DomTableSection = Section<
  {
    numColumns: 4 | 8 | 12;
    headline: string;
    tableDom: string;
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
    'tableDom',
  ],
  'dom-table' // TODO: check this and correct mock
>;

export function isDomTableSection(section: AnyInnerSection): section is DomTableSection {
  return section.component === 'dom-table';
}

@Component({
  selector: 'section[app-dom-table]',
  standalone: true,
  imports: [
    EditorIdDirective,
    HtmlComponent,
    FsButtonComponent,
],
  templateUrl: './dom-table.component.html',
  styleUrls: ['./dom-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DomTableComponent extends SectionComponent<DomTableSection> {

  protected attributeAllowlist = {
    'class': SecurityContext.NONE,
    'colspan': SecurityContext.NONE,
    'rowspan': SecurityContext.NONE,
    'scope': SecurityContext.NONE,
    ...DEFAULT_ATTRIBUTE_ALLOWLIST,
  };

}
